/* eslint-disable @typescript-eslint/no-explicit-any */
import sha256 from 'sha256';

export function generateUdid(key: any, randomKey: any) {
  return sha256(`${key}_${randomKey}`).substr(0, 16).toUpperCase();
}
